<template>
    <v-container fluid class="container-full-bg-gray">
        <app-page-card>
            <template #header>
                <app-row align="center">
                    <app-col>
                        Información Onboard
                    </app-col>
                    <app-col cols="3">
                        <!-- Buscador de usuario con autocompletado -->
                        <v-autocomplete
                            v-model="searchAllUserContractsUsername"
                            :items="allUsers"
                            item-text="username"
                            item-value="username"
                            label="Buscar usuario"
                            prepend-icon="mdi-account-search"
                            clearable
                            dense
                            autocomplete="off"
                            :class="{ 'search-active': isSearchingAllUserContracts }"
                            @change="onUserSearchChange"
                            @click:clear="clearUserSearch">
                        </v-autocomplete>
                    </app-col>
                    <app-col cols="auto" class="ml-auto d-flex align-center flex-column">
                        <div class="d-flex align-center">
                            <v-btn v-if="canMarkComisionesPagadas && selectedMonth && selectedYear"
                                   :disabled="markingComisiones || !hasPendingComisiones || isSearchingAllUserContracts"
                                   :loading="markingComisiones"
                                   @click="marcarComisionesPagadas"
                                   :color="hasAlreadyComisionedContracts && hasPendingComisiones ? 'warning' : 'success'"
                                   class="mr-2">
                                Marcar comisiones pagadas ({{ getMonthName(selectedMonth) }} {{ selectedYear }})
                            </v-btn>
                            <v-btn :disabled="false"
                                   @click="fetch_contracts"
                                   color="primary">
                                Refrescar
                            </v-btn>
                        </div>
                        <span v-if="hasAlreadyComisionedContracts && hasPendingComisiones && canMarkComisionesPagadas && selectedMonth && selectedYear && !isSearchingAllUserContracts"
                              class="warning--text text-caption mt-1">
                            ⚠️ Vigila, hay al menos un contrato ya comisionado.
                        </span>
                    </app-col>
                </app-row>
            </template>
            <template>
                <app-row>
                    <app-col cols="2">
                        <!-- Selector de mes -->
                        <v-select
                            :items="months"
                            label="Filtrar por mes"
                            v-model="selectedMonth"
                            :disabled="isSearchingAllUserContracts"
                            @change="changed_filters_month">
                        </v-select>
                    </app-col>
                    <app-col cols="2">
                        <!-- Selector d'any -->
                        <v-select
                            :items="years"
                            label="Filtrar por año"
                            v-model="selectedYear"
                            :disabled="isSearchingAllUserContracts"
                            @change="changed_filters_year">
                        </v-select>
                    </app-col>
                    <app-col cols="2" v-if="!isSupportUser">
                        <!-- Selector de comercial -->
                        <v-select
                            :items="tots_comercials"
                            label="Filtrar por comercial"
                            item-text="text"
                            item-value="value"
                            v-model="selectedComercial"
                            :disabled="isSearchingAllUserContracts"
                            @change="changed_filters_comercial">
                        </v-select>
                    </app-col>
                    <app-col cols="2">
                        <!-- es Prueba -->
                        <v-select
                            :items="opciones_prueba"
                            label="Filtrar por período de prueba"
                            item-text="text"
                            item-value="value"
                            v-model="selectedPrueba"
                            :disabled="isSearchingAllUserContracts"
                            @change="changed_filters_trial">
                        </v-select>
                    </app-col>
                    <app-col cols="2">
                        <!-- tipo de contrato -->
                        <v-select
                            :items="opciones_contract_type"
                            label="Filtrar por tipo de contrato"
                            item-text="text"
                            item-value="value"
                            v-model="selectedContractType"
                            :disabled="isSearchingAllUserContracts"
                            @change="changed_filters_contract_type">
                        </v-select>
                    </app-col>
                    <app-col cols="2" v-if="!isSupportUser">
                        <v-tooltip top>
                            <template v-slot:activator="{ on, attrs }">
                                <!-- contracts all/with/wuthout onboard -->
                                <div v-bind="attrs" v-on="on">

                                    <v-select
                                        :items="opciones_contract_onboard_type"
                                        label="Filtrar por contratos con/sin onboard"
                                        item-text="text"
                                        item-value="value"
                                        v-model="selectedContractOnboardType"
                                        :disabled="isSearchingAllUserContracts"
                                        @change="changed_filters_contract_onboard_type">
                                    </v-select>
                                </div>
                            </template>
                            <span>Onboard: Contratan por primera vez y hay comerciales involucrados o renuevan con menos de un año desde su llegada y se tiene en cuenta los comerciales que participaren en su primer contrato.<br><br>Sin Onboard: Renuevan y hace más de un año que están con nosotros o añaden un contrato con un paquete distinto (ej. tenían documentos y ahora cogen también bancos).<br><br>Todos: Todos los contratos contratados este mes. Especialmente útil para leer el Total de ingresos del mes, que aparece a bajo a la izquierda.</span>
                        </v-tooltip>
                    </app-col>
                </app-row>
                <app-row>
                    <v-card-text class="px-0 pt-0 card-title-footer-color">
                        <v-data-table
                            :items="contract_items"
                            :headers="contract_headers"
                            :items-per-page="limit"
                            :sort-by.sync="sortBy"
                            :sort-desc.sync="sortDesc"
                            @update:options="updateTableOptions"
                            @update:items-per-page="changeLimit"
                            @update:page="changePage"
                            :footer-props="{
                                'items-per-page-text': 'Contratos por página',
                                }"
                            :server-items-length="results_count"
                            :loading="loading"
                            :item-class="getRowClass"
                            fixed-header>
                            <!-- Headers con tooltips -->
                            <template v-for="header in contract_headers" v-slot:[`header.${header.value}`]="{ header: h }">
                                <span :key="`${header.value}-notooltip`" v-if="!header.tooltip">{{ header.text }}</span>
                                <v-tooltip :key="`${header.value}-tooltip`" v-else top>
                                    <template v-slot:activator="{ on, attrs }">
                                        <span v-bind="attrs" v-on="on" style="cursor: help; border-bottom: 1px dotted;">
                                            {{ header.text }}
                                        </span>
                                    </template>
                                    <span v-html="header.tooltip"></span>
                                </v-tooltip>
                            </template>
                            <template v-slot:item="{ item }">
                                <v-tooltip top :disabled="!item.contract_amount_higher_than_type && !item.contract_amount_lower_than_type && !item.contract_price_is_null && !item.contract_type_price_is_null && !item.contract_amount_higher_than_service_charge && !item.contract_amount_lower_than_service_charge && !item.service_charge_amount_is_null && !item.contract_duration_exceeds_year">
                                    <template v-slot:activator="{ on, attrs }">
                                        <tr v-bind="attrs" v-on="on" :class="getRowClass(item)">
                                            <td v-for="header in contract_headers" :key="header.value">
                                                <span class="font-color">
                                                    <slot v-if="header.value == 'flag_contract_checked'">
                                                        <v-checkbox
                                                            v-model="item.flag_contract_checked"
                                                            @change="toggleContractChecked(item)"
                                                            hide-details
                                                            dense
                                                            class="mt-0 pt-0"
                                                        ></v-checkbox>
                                                    </slot>
                                                    <slot v-else-if="header.value == 'has_onboard'">
                                                        {{computed_has_onboard(item[header.value])}}
                                                    </slot>
                                                    <slot v-else-if="header.value == 'amount'">
                                                        <i v-if="item[header.value] && item[header.value].toString().startsWith('-')">
                                                            {{item[header.value].replace('-','').replace('-','') }}
                                                        </i>
                                                        <span v-else>
                                                            {{item[header.value] }}
                                                        </span>
                                                    </slot>
                                                    <slot v-else-if="['who_signup','who_trained','who_closed_sale'].includes(header.value) && item[header.value] && item[header.value].startsWith('-')">
                                                        <i>{{item[header.value].replace('-','').replace('-','') }}</i>
                                                    </slot>
                                                    <slot v-else-if="header.value == 'id'">
                                                        <span
                                                            v-if="item['id'] && isViewerAdminUser"
                                                            @click.stop="goToAdminContracts(item['username'])"
                                                            class="primary--text accounting-link" >
                                                            {{ item['id'] }}
                                                        </span>
                                                        <span v-else-if="item['id']">
                                                            {{ item['id'] }}
                                                        </span>
                                                    </slot>
                                                    <slot v-else-if="header.value == 'is_trial'">
                                                        <v-icon :color="item.is_trial ? 'green' : 'red'" small>
                                                            {{ item.is_trial ? 'mdi-check' : 'mdi-close' }}
                                                        </v-icon>
                                                    </slot>
                                                    <slot v-else-if="header.value == 'comercials_mix_type'">
                                                        <v-icon :color="item.comercials_mix_type ? 'green' : 'red'" small>
                                                            {{ item.comercials_mix_type ? 'mdi-check' : 'mdi-close' }}
                                                        </v-icon>
                                                    </slot>
                                                    <slot v-else-if="header.value == 'is_trial_finished'">
                                                        <v-icon v-if="item.is_trial" :color="item.is_trial && item.is_trial_finished ? 'green' : 'red'" small>
                                                            {{ item.is_trial && item.is_trial_finished ? 'mdi-phone' : 'mdi-close' }}
                                                        </v-icon>
                                                    </slot>
                                                    <slot v-else-if="header.value == 'comissions_comercials'">
                                                        {{item[header.value] }}
                                                    </slot>
                                                    <slot v-else-if="header.value == 'import_comercials'">
                                                        {{item[header.value] }}
                                                    </slot>
                                                    <slot v-else-if="(header.value == 'creditos_trial_esperados' || header.value == 'diferencia_creditos_trial') && item.kind == 'documents'">
                                                        - - -
                                                    </slot>
                                                    <slot v-else-if="header.value == 'fecha_comision'">
                                                        <span v-if="item.fecha_comision && item.genero_comision === true" class="green--text">
                                                            {{ formatFechaComision(item.fecha_comision) }}
                                                        </span>
                                                        <span v-else-if="item.fecha_comision && item.genero_comision === false" class="grey--text">
                                                            Sin comisión
                                                        </span>
                                                        <span v-else-if="!item.has_onboard" class="grey--text">
                                                            No aplica
                                                        </span>
                                                        <span v-else class="grey--text">
                                                            Pendiente
                                                        </span>
                                                    </slot>
                                                    <slot v-else>
                                                        <span v-if="item[header.value] === null || item[header.value] === undefined || item[header.value] === ''">
                                                            - - -
                                                        </span>
                                                        <span v-else>
                                                            {{item[header.value] }}
                                                        </span>
                                                    </slot>
                                                </span>
                                            </td>
                                        </tr>
                                    </template>
                                    <div style="line-height: 1.5;">
                                        <div v-if="item.contract_price_is_null">
                                            ⚠️ Falta precio en el contrato
                                        </div>
                                        <div v-if="item.contract_amount_higher_than_type">
                                            ⚠️ El precio del contrato es mayor al precio del tipo de contrato
                                        </div>
                                        <div v-if="item.contract_amount_lower_than_type">
                                            ⚠️ El precio del contrato es menor al precio del tipo de contrato
                                        </div>
                                        <div v-if="!item.contract_price_is_null && item.contract_type_price_is_null">
                                            ⚠️ Falta precio en el tipo de contrato
                                        </div>
                                        <div v-if="item.contract_amount_higher_than_service_charge">
                                            ⚠️ El precio del contrato es mayor al precio del service charge
                                        </div>
                                        <div v-if="item.contract_amount_lower_than_service_charge">
                                            ⚠️ El precio del contrato es menor al precio del service charge
                                        </div>
                                        <div v-if="!item.contract_price_is_null && item.service_charge_amount_is_null">
                                            ⚠️ Falta precio en el service charge
                                        </div>
                                        <div v-if="item.contract_duration_exceeds_year">
                                            ⚠️ La duración del contrato excede el año y semana
                                        </div>
                                    </div>
                                </v-tooltip>
                            </template>

                        </v-data-table>
                        
                        <v-row>
                            <v-tooltip top>
                                <template v-slot:activator="{ on, attrs }">
                                    <div v-bind="attrs" v-on="on">                                       
                                        <v-card-title v-if="!isSupportUser">
                                            <strong>Total: </strong> <span style="margin-left: 8px;" v-if="!isSupportUser && selectedComercial===null && selectedPrueba==='Pasado el período de prueba'" >{{ totalAmount.toFixed(2) }}</span>
                                        </v-card-title>
                                    </div>
                                </template>
                                <span>
                                    El total de ingresos que aparece está determinado por los filtros aplicados:<br> 
                                    "Filtrar por comercial": No aparece si estamos filtrando por comercial.<br>
                                    "Filtrar por período de prueba": Tiene que estar en contratado.<br>
                                    "Filtrar por tipo de contrato": Si hay alguno seleccionado, solo se suman los contratos de ese tipo.<br>
                                    "Filtrar por contratos con/sin onboard": Si hay alguno seleccionado, solo se suman los contratos de ese tipo.<br>
                                </span>
                            </v-tooltip>
                                
                        </v-row>

                        <v-row>
                            
                            <!-- Si no eres Comercial i no has seleccionat ningú -->
                            <v-col cols="12" sm="6" md="2" v-if="!isSupportUser && selectedComercial===null" >
                                <v-card class="pa-2 ma-2">
                                    <!-- nom en negreta -->
                                    <v-card-title>
                                        <strong>Gemma</strong>
                                    </v-card-title>
                                    <div v-if="comercials['support.gemma']">
                                        <p><b>{{ comercials["support.gemma"]["participacions"]["nombre_de_contractes_en_els_quals_participa"] }}</b> contractes -> <b>{{ comercials["support.gemma"]["total"].toFixed(2) }}</b></p>
                                        <p v-if="isViewerAdminUser && comercials['support.gemma']['participacions']['contractes_mixtos'] > 0" class="warning--text">
                                            <v-icon color="warning" x-small>mdi-alert</v-icon>
                                            Contratos mixtos: <b>{{ comercials["support.gemma"]["participacions"]["contractes_mixtos"] }}</b>
                                        </p>
                                        <!-- Bloque de Participaciones -->
                                        <v-card-subtitle class="mt-2">
                                            <strong>Participaciones:</strong>
                                        </v-card-subtitle>
                                        <v-card-text>
                                            <p>Altas: <b>{{ comercials["support.gemma"]["participacions"]["signup"] }}</b></p>
                                            <p>Formaciones: <b>{{ comercials["support.gemma"]["participacions"]["trained"] }}</b></p>
                                            <p>Cierres: <b>{{ comercials["support.gemma"]["participacions"]["closed_sale"] }}</b></p>
                                            <p>Totales: <b>{{ comercials["support.gemma"]["participacions"]["total"] }}</b></p>
                                        </v-card-text>    
                                        <!-- Bloque de Comisiones -->
                                        <v-card-subtitle class="mt-2">
                                            <strong>Comisiones:</strong>
                                        </v-card-subtitle>
                                        <v-card-text>
                                            <p>Altas: <b>{{ comercials["support.gemma"]["comissions"]["signup"].toFixed(2) }}</b></p>
                                            <p>Formaciones: <b>{{ comercials["support.gemma"]["comissions"]["trained"].toFixed(2) }}</b></p>
                                            <p>Cierres: <b>{{ comercials["support.gemma"]["comissions"]["closed_sale"].toFixed(2) }}</b></p>
                                            <p>Totales: <b>{{ comercials["support.gemma"]["comissions"]["total"].toFixed(2) }}</b></p>
                                        </v-card-text>
                                    </div>
                                </v-card>
                            </v-col>
                            
                            <!-- Si no eres Comercial i no has seleccionat ningú o si has seleccionat el joan. també ho veu el joan pq quan entra "se seleccioan a sí mateix" -->
                            <v-col cols="12" sm="6" md="2" v-if="!isSupportUser && selectedComercial===null || selectedComercial==='soporte.joan'" >
                                <v-card class="pa-2 ma-2">
                                    <!-- nom en negreta -->
                                    <v-card-title>
                                        <strong>Joan</strong>
                                    </v-card-title>
                                    <div v-if="comercials['soporte.joan']">
                                        <p><b>{{ comercials["soporte.joan"]["participacions"]["nombre_de_contractes_en_els_quals_participa"] }}</b> contractes -> <b>{{ comercials["soporte.joan"]["total"].toFixed(2) }}</b></p>
                                        <p v-if="isViewerAdminUser && comercials['soporte.joan']['participacions']['contractes_mixtos'] > 0" class="warning--text">
                                            <v-icon color="warning" x-small>mdi-alert</v-icon>
                                            Contratos mixtos: <b>{{ comercials["soporte.joan"]["participacions"]["contractes_mixtos"] }}</b>
                                        </p>
                                        <!-- Bloque de Participaciones -->
                                        <v-card-subtitle class="mt-2">
                                            <strong>Participaciones:</strong>
                                        </v-card-subtitle>
                                        <v-card-text>
                                            <p>Altas: <b>{{ comercials["soporte.joan"]["participacions"]["signup"] }}</b></p>
                                            <p>Formaciones: <b>{{ comercials["soporte.joan"]["participacions"]["trained"] }}</b></p>
                                            <p>Cierres: <b>{{ comercials["soporte.joan"]["participacions"]["closed_sale"] }}</b></p>
                                            <p>Totales: <b>{{ comercials["soporte.joan"]["participacions"]["total"] }}</b></p>
                                        </v-card-text>                                
                                        <!-- Bloque de Comisiones -->
                                        <v-card-subtitle class="mt-2">
                                            <strong>Comisiones:</strong>
                                        </v-card-subtitle>
                                        <v-card-text>
                                            <p>Altas: <b>{{ comercials["soporte.joan"]["comissions"]["signup"].toFixed(2) }}</b></p>
                                            <p>Formaciones: <b>{{ comercials["soporte.joan"]["comissions"]["trained"].toFixed(2) }}</b></p>
                                            <p>Cierres: <b>{{ comercials["soporte.joan"]["comissions"]["closed_sale"].toFixed(2) }}</b></p>
                                            <p>Totales: <b>{{ comercials["soporte.joan"]["comissions"]["total"].toFixed(2) }}</b></p>
                                        </v-card-text>
                                    </div>
                                </v-card>
                            </v-col>
                            
                            
                            
                            <v-col cols="12" sm="6" md="2" v-if="!isSupportUser && selectedComercial===null || selectedComercial==='support.rosana'">
                                <v-card class="pa-2 ma-2">
                                    <!-- nom en negreta -->
                                    <v-card-title>
                                        <strong>Rosana</strong>
                                    </v-card-title>
                                    <div v-if="comercials['support.rosana']">
                                        <p><b>{{ comercials["support.rosana"]["participacions"]["nombre_de_contractes_en_els_quals_participa"] }}</b> contractes -> <b>{{ comercials["support.rosana"]["total"].toFixed(2) }}</b></p>
                                        <p v-if="isViewerAdminUser && comercials['support.rosana']['participacions']['contractes_mixtos'] > 0" class="warning--text">
                                            <v-icon color="warning" x-small>mdi-alert</v-icon>
                                            Contratos mixtos: <b>{{ comercials["support.rosana"]["participacions"]["contractes_mixtos"] }}</b>
                                        </p>
                                        <!-- Bloque de Participaciones -->
                                        <v-card-subtitle class="mt-2">
                                            <strong>Participaciones:</strong>
                                        </v-card-subtitle>
                                        <v-card-text>
                                            <p>Altas: <b>{{ comercials["support.rosana"]["participacions"]["signup"] }}</b></p>
                                            <p>Formaciones: <b>{{ comercials["support.rosana"]["participacions"]["trained"] }}</b></p>
                                            <p>Cierres: <b>{{ comercials["support.rosana"]["participacions"]["closed_sale"] }}</b></p>
                                            <p>Totales: <b>{{ comercials["support.rosana"]["participacions"]["total"] }}</b></p>
                                        </v-card-text>
                                        <!-- Bloque de Comisiones -->
                                        <v-card-subtitle class="mt-2">
                                            <strong>Comisiones:</strong>
                                        </v-card-subtitle>
                                        <v-card-text>
                                            <p>Altas: <b>{{ comercials["support.rosana"]["comissions"]["signup"].toFixed(2) }}</b></p>
                                            <p>Formaciones: <b>{{ comercials["support.rosana"]["comissions"]["trained"].toFixed(2) }}</b></p>
                                            <p>Cierres: <b>{{ comercials["support.rosana"]["comissions"]["closed_sale"].toFixed(2) }}</b></p>
                                            <p>Totales: <b>{{ comercials["support.rosana"]["comissions"]["total"].toFixed(2) }}</b></p>
                                        </v-card-text>
                                    </div>
                                </v-card>
                            </v-col>

                            
                            <v-col cols="12" sm="6" md="2" v-if="!isSupportUser && selectedComercial===null || selectedComercial==='support.daniel_luna'">
                                <v-card class="pa-2 ma-2">
                                    <!-- nom en negreta -->
                                    <v-card-title>
                                        <strong>Daniel Luna</strong>
                                    </v-card-title>
                                    <div v-if="comercials['support.daniel_luna']">
                                        <p><b>{{ comercials["support.daniel_luna"]["participacions"]["nombre_de_contractes_en_els_quals_participa"] }}</b> contractes -> <b>{{ comercials["support.daniel_luna"]["total"].toFixed(2) }}</b></p>
                                        <p v-if="isViewerAdminUser && comercials['support.daniel_luna']['participacions']['contractes_mixtos'] > 0" class="warning--text">
                                            <v-icon color="warning" x-small>mdi-alert</v-icon>
                                            Contratos mixtos: <b>{{ comercials["support.daniel_luna"]["participacions"]["contractes_mixtos"] }}</b>
                                        </p>
                                        <!-- Bloque de Participaciones -->
                                        <v-card-subtitle class="mt-2">
                                            <strong>Participaciones:</strong>
                                        </v-card-subtitle>
                                        <v-card-text>
                                            <p>Altas: <b>{{ comercials["support.daniel_luna"]["participacions"]["signup"] }}</b></p>
                                            <p>Formaciones: <b>{{ comercials["support.daniel_luna"]["participacions"]["trained"] }}</b></p>
                                            <p>Cierres: <b>{{ comercials["support.daniel_luna"]["participacions"]["closed_sale"] }}</b></p>
                                            <p>Totales: <b>{{ comercials["support.daniel_luna"]["participacions"]["total"] }}</b></p>
                                        </v-card-text>
                                        <!-- Bloque de Comisiones -->
                                        <v-card-subtitle class="mt-2">
                                            <strong>Comisiones:</strong>
                                        </v-card-subtitle>
                                        <v-card-text>
                                            <p>Altas: <b>{{ comercials["support.daniel_luna"]["comissions"]["signup"].toFixed(2) }}</b></p>
                                            <p>Formaciones: <b>{{ comercials["support.daniel_luna"]["comissions"]["trained"].toFixed(2) }}</b></p>
                                            <p>Cierres: <b>{{ comercials["support.daniel_luna"]["comissions"]["closed_sale"].toFixed(2) }}</b></p>
                                            <p>Totales: <b>{{ comercials["support.daniel_luna"]["comissions"]["total"].toFixed(2) }}</b></p>
                                        </v-card-text>
                                    </div>
                                </v-card>
                            </v-col>

                            
                            <v-col cols="12" sm="6" md="2" v-if="!isSupportUser && selectedComercial===null || selectedComercial==='support.carlos'">
                                <v-card class="pa-2 ma-2">
                                    <!-- nom en negreta -->
                                    <v-card-title>
                                        <strong>Carlos</strong>
                                    </v-card-title>
                                    <div v-if="comercials['support.carlos']">
                                        <p><b>{{ comercials["support.carlos"]["participacions"]["nombre_de_contractes_en_els_quals_participa"] }}</b> contractes -> <b>{{ comercials["support.carlos"]["total"].toFixed(2) }}</b></p>
                                        <p v-if="isViewerAdminUser && comercials['support.carlos']['participacions']['contractes_mixtos'] > 0" class="warning--text">
                                            <v-icon color="warning" x-small>mdi-alert</v-icon>
                                            Contratos mixtos: <b>{{ comercials["support.carlos"]["participacions"]["contractes_mixtos"] }}</b>
                                        </p>
                                        <!-- Bloque de Participaciones -->
                                        <v-card-subtitle class="mt-2">
                                            <strong>Participaciones:</strong>
                                        </v-card-subtitle>
                                        <v-card-text>
                                            <p>Altas: <b>{{ comercials["support.carlos"]["participacions"]["signup"] }}</b></p>
                                            <p>Formaciones: <b>{{ comercials["support.carlos"]["participacions"]["trained"] }}</b></p>
                                            <p>Cierres: <b>{{ comercials["support.carlos"]["participacions"]["closed_sale"] }}</b></p>
                                            <p>Totales: <b>{{ comercials["support.carlos"]["participacions"]["total"] }}</b></p>
                                        </v-card-text>
                                        <!-- Bloque de Comisiones -->
                                        <v-card-subtitle class="mt-2">
                                            <strong>Comisiones:</strong>
                                        </v-card-subtitle>
                                        <v-card-text>
                                            <p>Altas: <b>{{ comercials["support.carlos"]["comissions"]["signup"].toFixed(2) }}</b></p>
                                            <p>Formaciones: <b>{{ comercials["support.carlos"]["comissions"]["trained"].toFixed(2) }}</b></p>
                                            <p>Cierres: <b>{{ comercials["support.carlos"]["comissions"]["closed_sale"].toFixed(2) }}</b></p>
                                            <p>Totales: <b>{{ comercials["support.carlos"]["comissions"]["total"].toFixed(2) }}</b></p>
                                        </v-card-text>
                                    </div>
                                </v-card>
                            </v-col>
                            
                        </v-row>
                    </v-card-text>
                </app-row>
            </template>
        </app-page-card>
    </v-container>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import DataTableWithApi from '../components/DataTableWithApi.vue'
import AppPageCard from '@/components/layout/AppPageCard.vue';
import AppRow from '@/components/layout/AppRow.vue';
import AppCol from '@/components/layout/AppCol.vue';
import { user } from '@/api/user';
import { query_dispatcher_get, query_dispatcher, sync_command_dispatcher, client } from "@/api/client";
import { get_tree_from_schema } from '@/modules/entities/domain/GetTreeFromSchema';


export default {
    name: 'OnboardInformation',
    components: {
        AppCol,
        AppRow,
        AppPageCard,
        DataTableWithApi
    },
    data() {
        // const screen_data = new VueContractOnboardListScreenData();
        return {
            contract_items:[],
            results_count:0,
            loading:false,
            loadingUsers: false,
            markingComisiones: false,
            limit:-1,
            offset:0,
            totalAmount: 0,
            comercials:{},
            sortBy: 'start_date',
            sortDesc: false,
            selectedMonth: (new Date().getMonth() + 1).toString().padStart(2, '0'), //el métode padStart ompli el començament d'un string amb una cadena fins que se s'arribi al nombre de dígits demanat.
            //selectedMonth: '11',
            months: [
                { text: 'Enero', value: '01' },
                { text: 'Febrero', value: '02' },
                { text: 'Marzo', value: '03' },
                { text: 'Abril', value: '04' },
                { text: 'Mayo', value: '05' },
                { text: 'Junio', value: '06' },
                { text: 'Julio', value: '07' },
                { text: 'Agosto', value: '08' },
                { text: 'Septiembre', value: '09' },
                { text: 'Octubre', value: '10' },
                { text: 'Noviembre', value: '11' },
                { text: 'Diciembre', value: '12' }
            ],
            selectedYear: new Date().getFullYear().toString(),
            //selectedYear: '2024',
            selectedUser: null,
            users: [
                {text: 'Todos los usuarios', value: null},
                {text: 'usuari support.narcis', value: 'support.narcis'},
                {text: 'usuari support.mauro', value: 'support.mauro'},
                {text: 'usuari support.biel', value: 'support.biel'},

            ],
            selectedComercial: null,
            tots_comercials:[
                {text: 'Todos los comerciales', value: null},                                
                {text: 'support.rosana', value: 'support.rosana'},
                {text: 'soporte.joan', value: 'soporte.joan'},                
                {text: 'support.carlos', value: 'support.carlos'},
                {text: 'support.daniel_luna', value: 'support.daniel_luna'},
                {text: 'support.gemma', value: 'support.gemma'},
            ],
            selectedPrueba:'Pasado el período de prueba',
            opciones_prueba:[
                {text: 'Todos los contratos', value: null},
                {text: 'En período de prueba', value: 'En período de prueba'},
                {text: 'Contratado', value: 'Pasado el período de prueba'}
            ],
            selectedContractType:null,
            opciones_contract_type:[
                {text: 'Todos los tipos de paquetes', value: null},
                {text: 'Paquete de Documentos', value: 'documents'},
                {text: 'Paquete de Bancos', value: 'banks'},
                {text: 'Paquete de Créditos Gestor Documental', value: 'credits'},
                {text: 'Paquete de Créditos Factura Electrónica', value: 'facturae_credits'},
            ],
            selectedContractOnboardType:null,
            opciones_contract_onboard_type:[
                {text: 'Todos los contratos', value: 'with_without_onboard'},
                {text: 'Con Onboard', value: null},
                {text: 'Sin Onboard', value: 'without_onboard'},
            ],
            searchAllUserContractsUsername: null,
            allUsers: [],

        }
    },
    computed: {
        contract_headers() {
            const showComisionDetails = this.selectedComercial || this.isSupportUser;

            return [
                ...(this.canSeeContractChecked ? [{ text: 'Revisado', value: 'flag_contract_checked', tooltip: 'Marcar contrato como revisado' }] : []),
                { text: 'ID Contracte', value: 'id' },
                { text: 'Usuario', value: 'username' },
                { text: 'Fecha Inicio', value: 'start_date' },
                { text: 'Fecha Final', value: 'end_date', tooltip: 'Concesiones no tienen fecha final. Por tanto superan año' },
                { text: 'Fecha de Cobro', value: 'charge_date' },
                { text: 'Alta', value: 'who_signup' },
                { text: 'Formador', value: 'who_trained' },
                { text: 'Cierre', value: 'who_closed_sale' },
                ...(this.isViewerAdminUser ? [
                    { text: 'Mixto', value: 'comercials_mix_type', tooltip: 'Indica si hay más de un comercial distinto en el contrato (signup, trained, closed_sale)' }
                ] : []),
                { text: 'Cantidad', value: 'amount' },
                ...(showComisionDetails ? [
                    { text: 'Comisión', value: 'comissions_comercials' },
                    { text: 'Importe', value: 'import_comercials' },
                ] : []),
                { text: 'Prueba', value: 'is_trial' },
                { text: 'Nombre Contrato', value: 'name' },
                { text: 'Créditos', value: 'creditos', tooltip: 'Créditos a consumir' },
                { text: 'Créditos Esperados', value: 'creditos_esperados', tooltip: 'Créditos a consumir según su tipo de contrato' },
                { text: 'Exceso de Créditos', value: 'diferencia_creditos', tooltip: 'Diferencia entre los créditos consumidos y los esperados (positivo = exceso)' },
                { text: 'Créditos Trial', value: 'creditos_trial', tooltip: 'Créditos a consumir durante el período de prueba' },
                { text: 'Créditos Trial Esperados', value: 'creditos_trial_esperados', tooltip: 'Créditos a consumir durante el período de prueba según su tipo de contrato.<br>No aplica a contratos de tipo "documents" ya que no tienen un límite trial por defecto' },
                { text: 'Exceso de Créditos Trial', value: 'diferencia_creditos_trial', tooltip: 'Diferencia entre los créditos trial consumidos y los esperados (positivo = exceso).<br>No aplica a contratos de tipo "documents" ya que no tienen un límite trial por defecto' },
                { text: 'Comisión Pagada', value: 'fecha_comision', tooltip: 'Estado de la comisión:<br>- Fecha en verde: Comisión pagada<br>- "Sin comisión": No generó comisión (precio ≤ 0)<br>- "No aplica": Sin onboard<br>- "Pendiente": No procesado aún' }
            ];
        },

        currentPage(){
            return Math.trunc(this.offset/this.limit)+1
        },
        years() {
            // Genera años desde 2023 hasta el año actual + 2
            const currentYear = new Date().getFullYear();
            const startYear = 2023;
            const endYear = currentYear + 5;
            const yearsList = [];
            for (let year = startYear; year <= endYear; year++) {
                yearsList.push({
                    text: year.toString(),
                    value: year.toString()
                });
            }
            return yearsList;
        },
        ...mapGetters({userData: 'me/userData'}),

        isSupportUser() {
            const supportUsernames = ['support.rosana', 'support.daniel_luna', 'support.carlos', 'soporte.joan'];
            //const supportUsernames = ['gemma.demo', 'support.rosana', 'support.daniel_luna', 'support.carlos', 'soporte.joan']; #això simplement ho tinc per veure la vista des d'un supporter.
            return supportUsernames.includes(this.userData.username);
        },
        isSearchingAllUserContracts() {
            return this.searchAllUserContractsUsername !== null;
        },
        // supportUser(){
        //     return this.userData.username;
        // },

        adminContractUsernames(){
            return ['test.toni', 'mauro', 'gemma.demo', 'support.biel', 'support.gemma', 'support.maria'];
        },
        isViewerAdminUser(){ // linkejo al contracte d'admin
            return this.adminContractUsernames.includes(this.userData.username);
        },
        canSeeContractChecked(){
            return this.adminContractUsernames.includes(this.userData.username);
        },
        canMarkComisionesPagadas(){
            return this.adminContractUsernames.includes(this.userData.username);
        },
        hasPendingComisiones(){
            // Verificar si hay contratos con onboard, no trial, y sin fecha_comision
            return this.contract_items.some(item =>
                item.has_onboard === true &&
                item.is_trial === false &&
                item.fecha_comision === null
            );
        },
        hasAlreadyComisionedContracts(){
            // Verificar si hay contratos con onboard, no trial, y CON fecha_comision
            return this.contract_items.some(item =>
                item.has_onboard === true &&
                item.is_trial === false &&
                item.fecha_comision !== null
            );
        },

    },
    methods: {
        updateTableOptions(options) {
            // Manejar cambios de ordenación desde el v-data-table
            if (options.sortBy && options.sortBy.length > 0) {
                this.sortBy = options.sortBy[0]
                this.sortDesc = options.sortDesc[0]
            } else {
                // Si no hay ordenación, usar la ordenación por defecto
                this.sortBy = 'start_date'
                this.sortDesc = false
            }
            this.fetch_contracts()
        },
        getRowClass(item) {
            // Verificar si hay algún error
            const hasAnyError = item.contract_amount_higher_than_type ||
                                item.contract_amount_lower_than_type ||
                                item.contract_price_is_null ||
                                item.contract_type_price_is_null ||
                                item.contract_amount_higher_than_service_charge ||
                                item.contract_amount_lower_than_service_charge ||
                                item.service_charge_amount_is_null ||
                                item.contract_duration_exceeds_year;

            return hasAnyError ? 'contract-error-row' : '';
        },
        computed_has_onboard(has_onboard){
            if(has_onboard){
                return 'SÍ'
            }
            else{
                return 'NO'
            }
        },
        changed_filters_comercial(){
            console.log("Comercial seleccionado:", this.selectedComercial);
            this.selectedContractOnboardType = null;
            this.offset = 0
            this.fetch_contracts()
        },
        //quan se selecciona un mes, si no se selecciona un any el backend selecciona automàticament l'any acutal.
        // vull que aquesta selecció automàtica es vegi reflexada en el frontend. 
        changed_filters_month(){ 
            this.offset = 0
            if (this.selectedMonth && !this.selectedYear){ //si tenim un mes seleccionat però cap any
                this.selectedYear = new Date().getFullYear().toString();
            }

            this.fetch_contracts()
        },
        //quan se deselecciona un any, el backend selecciona automàticament l'any acutal. 
        //per tant, si hi ha un mes seleccionat, pot donar lloc a confusions, així que deselecciono també el mes. 
        changed_filters_year(){ 
            this.offset = 0
            if (this.selectedMonth && !this.selectedYear){ //si tenim un mes seleccionat però cap any
                this.selectedMonth = null;
            }
            this.fetch_contracts()
        },
        changed_filters_trial(){
            this.offset=0
            this.fetch_contracts()
        },
        changed_filters_contract_type(){
            this.offset=0
            this.fetch_contracts()
        },
        changed_filters_contract_onboard_type(){
            this.offset=0
            this.selectedComercial = null
            this.selectedPrueba = 'Pasado el período de prueba'
            this.fetch_contracts()
        },
        // Cuando se selecciona un usuario del autocomplete
        onUserSearchChange(username){
            if (username) {
                this.offset = 0;
                this.fetch_contracts();
            }
        },
        // Limpiar búsqueda por usuario y volver a filtros normales
        clearUserSearch(){
            this.searchAllUserContractsUsername = null;
            this.offset = 0;
            this.fetch_contracts();
        },
        // Cargar usuarios para autocompletado (prenc exemple de GuidelineEditor)
        get_users() {
            client.get('get_users_to_loginas/').then(response => {
                this.allUsers = response.data;
            }).catch(err => {
                console.error("Error loading users:", err);
            });
        },
        async fetch_contracts(){
            //
            let args= {'force_get':true}
            if (this.limit){
                args['limit'] = this.limit
            }
            if (this.offset){
                args['offset'] = this.offset
            }
            //
            let query_args = {}

            // Si estamos buscando todos los contratos de un usuario, solo enviamos ese parámetro
            if (this.searchAllUserContractsUsername) {
                query_args['search_all_user_contracts'] = this.searchAllUserContractsUsername
            } else {
                // Filtros normales (solo cuando NO estamos en modo búsqueda por usuario)
                if (this.selectedMonth) { // Agreguem el filtre de mes si existeix
                    query_args['month'] = this.selectedMonth
                }
                if (this.selectedYear) {
                    query_args['year'] = this.selectedYear
                }
                if (this.selectedUser) {
                    query_args['user'] = this.selectedUser
                }
                if (this.isSupportUser){
                    this.selectedComercial=this.userData.username;
                    query_args['comercial'] = this.selectedComercial
                }else if (this.selectedComercial){
                    query_args['comercial'] = this.selectedComercial
                }
                if (this.selectedPrueba){
                    query_args['prueba'] = this.selectedPrueba
                }
                if (this.selectedContractType){
                    query_args['contract_type'] = this.selectedContractType
                }
                if (this.selectedContractOnboardType){
                    query_args['contract_onboard_type'] = this.selectedContractOnboardType
                }
            }

            // Enviar parámetros de ordenación
            if (this.sortBy) {
                query_args['sort_by'] = this.sortBy
                query_args['sort_desc'] = this.sortDesc
            }

            args['args'] = query_args
            
            this.loading = true //indica en el frontend que la càrrega de dades ha començat
            let res = await query_dispatcher_get.dispatch('get.contracts.with.onboard.info', args) //fa una crida asíncrona al backend. 
            // el primer arg que passa és l'endpoint o acció específica del backend que s'està invocant i args és els paràmetres que s'enviaran per a la petició
            console.log("res", res)
            this.contract_items = res['results']
            this.totalAmount=res['total_amount']
            this.results_count = res['count']
            this.participacions = res['participacions']
            this.comercials = res['comercials']

            this.loading = false
        },
        changeLimit(value){
            this.limit = value
            this.fetch_contracts()
        },
        changePage(value){
            this.offset = (value-1)*this.limit
            this.fetch_contracts()
        },
        goToAdminContracts(username){
            console.log("goToAdminContracts per a l'usuari", username)
            // let path = '/admin/adp/contract/?q=&user__id__exact=14' així ens caldria a partir del contracte de l'usuari obtindre l'id de l'usuari. però veig que hi ha dues maneres diferents per arribar al mateix lloc. me quedo amb la segona.
            let path = '/admin/adp/contract/?q='+username
            let href = window.location.origin.replace('app', 'api') + path;
            window.open(href, '_blank');

        },
        async toggleContractChecked(item){
            try {
                let res = await sync_command_dispatcher.dispatch('set.contract.checked', {
                    contract_id: item.id,
                    checked: item.flag_contract_checked
                });
                console.log("toggleContractChecked result:", res);
            } catch (error) {
                console.error("Error al actualizar flag_contract_checked:", error);
                // Revertir el cambio en caso de error
                item.flag_contract_checked = !item.flag_contract_checked;
            }
        },
        async marcarComisionesPagadas(){
            if (!this.selectedMonth || !this.selectedYear) {
                return;
            }
            if (!confirm(`¿Estás seguro de marcar como pagadas las comisiones de ${this.getMonthName(this.selectedMonth)} ${this.selectedYear}?`)) {
                return;
            }
            this.markingComisiones = true;
            try {
                let res = await sync_command_dispatcher.dispatch('set.comision.pagada', {
                    month: parseInt(this.selectedMonth),
                    year: parseInt(this.selectedYear)
                });
                console.log("marcarComisionesPagadas result:", res);
                // La respuesta viene envuelta en res.output
                let output = res.output || res;
                if (output.success) {
                    alert(`Comisiones marcadas como pagadas: ${output.updated_count} registros actualizados.`);
                    this.fetch_contracts();
                } else {
                    alert(`Error: ${output.error || 'Error desconocido'}`);
                }
            } catch (error) {
                console.error("Error al marcar comisiones pagadas:", error);
                alert("Error al marcar comisiones pagadas: " + error.message);
            } finally {
                this.markingComisiones = false;
            }
        },
        formatFechaComision(fecha){
            if (!fecha) return '';
            const date = new Date(fecha);
            return date.toLocaleDateString('es-ES', { day: '2-digit', month: '2-digit', year: 'numeric' });
        },
        getMonthName(monthValue){
            const monthNames = {
                '01': 'Enero', '02': 'Febrero', '03': 'Marzo', '04': 'Abril',
                '05': 'Mayo', '06': 'Junio', '07': 'Julio', '08': 'Agosto',
                '09': 'Septiembre', '10': 'Octubre', '11': 'Noviembre', '12': 'Diciembre'
            };
            return monthNames[monthValue] || monthValue;
        },

    },
    async mounted(){
        this.get_users();
        this.fetch_contracts();
    },

}
</script>

<style scoped>

    /*fixar capçalera.*/
    ::v-deep .v-data-table-header>tr>th {
        position: sticky;
        top: 0;
        z-index: 2;
        background-color: var(--v-primaryLight-base) !important;
    }

    /*fixar capçalera*/
    ::v-deep .v-data-table__wrapper {
    max-height: calc(100vh - 270px);
    overflow-y: auto;
    }

    /* Marcar filas con cualquier error - Color anaranjado claro unificado */
    ::v-deep .contract-error-row {
        background-color: #ffe6cc !important;
    }

    ::v-deep .contract-error-row:hover {
        background-color: #ffd9b3 !important;
    }

    /* Centrar todas las celdas de la tabla */
    ::v-deep .v-data-table tbody td {
        text-align: center !important;
        border-right: 1px solid #e0e0e0 !important;
    }

    ::v-deep .v-data-table thead th {
        text-align: center !important;
        border-right: 1px solid #e0e0e0 !important;
    }

    /* Eliminar el borde de la última columna */
    ::v-deep .v-data-table tbody td:last-child {
        border-right: none !important;
    }

    ::v-deep .v-data-table thead th:last-child {
        border-right: none !important;
    }

    /* Ancho mínimo para columnas de fecha */
    ::v-deep .v-data-table td,
    ::v-deep .v-data-table th {
        white-space: nowrap;
    }

    /* Estilo para el buscador de usuario cuando está activo */
    ::v-deep .search-active input {
        color: var(--v-primary-base) !important;
        font-weight: bold;
    }

    ::v-deep .search-active .v-input__slot {
        background-color: rgba(var(--v-primary-base), 0.05);
    }

</style>